import { render, staticRenderFns } from "./CdbCustomerAddress.vue?vue&type=template&id=15cbea3c&scoped=true&"
import script from "./CdbCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerAddress.vue?vue&type=style&index=0&id=15cbea3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cbea3c",
  null
  
)

export default component.exports